/**
 * Brand-guide copy rules applied to CMS text (Google Sheets) at load time, so the
 * live site complies even when a sheet cell still carries legacy wording.
 *
 * Rule (non-negotiable): never state a hard dollar figure for assets/projects
 * under management — soften "$50M+" style claims to "multi-million-dollar".
 */
const RULES = [
  [/trusted to manage over \$\s?50\s?m\b[^.]*\./gi, 'Trusted with multi-million-dollar technical asset portfolios.'],
  [/(governs?|manag(?:es|ed|ing)?)\s+over\s+\$\s?50\s?m\+?\s+(in\s+)?/gi, '$1 a multi-million-dollar portfolio of '],
  [/(with) over \$\s?50\s?m\+?\s+in\s+/gi, '$1 a multi-million-dollar portfolio of '],
  [/\$\s?50\s?m\+?\s+(in\s+)?technical assets/gi, 'multi-million-dollar technical asset portfolios'],
  [/assets managed:\s*\$\s?50\s?m\+?/gi, 'Assets managed: multi-million-dollar portfolio'],
  [/\$\s?50\s?m\+?/gi, 'multi-million-dollar'],
];

export function softenFigures(text) {
  if (typeof text !== 'string' || !/50\s?m/i.test(text)) return text;
  return RULES.reduce((t, [re, rep]) => t.replace(re, rep), text);
}

/** Apply softenFigures to every string in a plain object / array (deep). */
export function softenDeep(value) {
  if (typeof value === 'string') return softenFigures(value);
  if (Array.isArray(value)) return value.map(softenDeep);
  if (value && typeof value === 'object') {
    const out = {};
    for (const k of Object.keys(value)) out[k] = softenDeep(value[k]);
    return out;
  }
  return value;
}
